export default __webpack_public_path__ + "static/media/result2.b02c02bd.png";